import { SITE_CONFIG } from '../config';

export const decryptPassword = (cipherBase64) => {
  if (!cipherBase64 || !SITE_CONFIG.SENDER_EMAIL_ENCRYPTION_KEY) return Promise.resolve(null);
  try {
    const key = Uint8Array.from(SITE_CONFIG.SENDER_EMAIL_ENCRYPTION_KEY.match(/.{2}/g).map(b => parseInt(b, 16)));
    const raw = Uint8Array.from(atob(cipherBase64), c => c.charCodeAt(0));
    const iv = raw.slice(0, 16);
    const data = raw.slice(16);
    return crypto.subtle.importKey('raw', key, 'AES-CBC', false, ['decrypt'])
      .then(k => crypto.subtle.decrypt({ name: 'AES-CBC', iv }, k, data))
      .then(buf => new TextDecoder().decode(buf))
      .catch(() => null);
  } catch {
    return Promise.resolve(null);
  }
};
